import { gql, TypedDocumentNode } from '@apollo/client';

import { JobBoardDto, QueryGetGuestPotentialJobsArgs } from '@pflegia/data-access';

import { JOB_POSITION_FOR_GUEST_FRAGMENT } from '../fragments/job-position-for-guest';

export const GET_NOT_LOGGED_JOB_POSITIONS_LIST: TypedDocumentNode<{ data: JobBoardDto }, QueryGetGuestPotentialJobsArgs> = gql`
  query getPotentialJobs(
    $sortField: String!
    $sortOrder: String
    $page: Int!
    $perPage: Int!
    $filters: JobBoardFiltersInput!
    $isMinifiedJobBoard: Boolean
    $isTransparentJobBoard: Boolean
  ) {
    data: getGuestPotentialJobs(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filters: $filters
      isMinifiedJobBoard: $isMinifiedJobBoard
      isTransparentJobBoard: $isTransparentJobBoard
    ) {
      total
      jobPositions {
        ...JobPositionForGuest
        recommended
        score
      }
      extendedJobPositions {
        ...JobPositionForGuest
        recommended
        score
      }
      extendedTotal
    }
  }
  ${JOB_POSITION_FOR_GUEST_FRAGMENT}
`;
